<!--模板界面-->
<template>
	<div>
		<createMeterDialog ref="createMeterBean" @createSuccess="$emit('updateMeter',$event)"></createMeterDialog>
		<div class="flexStart">
			<iconButton icoName="wedoButton/point_left.png" buttonText="返回列表" @buttonClick="closeDetails" style="margin-top: 10px;"></iconButton>
			<iconButton v-if="showControl" icoName="wedoButton/edit.png" buttonText="编辑配置" @buttonClick="editMeter" style="margin-top: 10px;"></iconButton>
		</div>
		<div class="meterDetailBody" style="height: calc(100% - 37px);">
			<div class="flexBetween">
				<div class="flexBetween" :style="[haveMargin]">
					<div class="detailDiv" style="width: calc(50% - 5px);height: 154px;margin-right: 10px;">
						<p class="detailTitle">设备信息</p>
						<div>
							<p class="infoItemContainer"><span class="infoTitle">设备名称 : </span><span class="infoContent">{{nowMeter.deviceName}}</span></p>
							<p class="infoItemContainer"><span class="infoTitle">设备状态 : </span><span class="infoContent">{{nowMeter.state == 0 ? '正常':'欠费'}}</span></p>
							<p class="infoItemContainer"><span class="infoTitle">余额：</span><span class="infoContent"><span class="moneyNum">{{nowBalance}}</span> 元</span></p>
						</div>
					</div>
					<div class="detailDiv" style="width: calc(50% - 5px);height: 154px;">
						<p class="detailTitle">抄表信息</p>
						<div>
							<p class="infoItemContainer"><span class="infoTitle">抄表日：</span><span class="infoContent">每月 {{nowMeter.deductionFeeDay}} 日</span></p>
							<p class="infoItemContainer"><span class="infoTitle">计费方式：</span><span class="infoContent">【{{billingMode(nowMeter.billingMode)}}】</span></p>
							<p class="infoItemContainer"><span class="infoTitle">上次抄表时间：</span><span class="infoContent">{{nowMeter.lastDeductionFeeTime == undefined?'--':new Date(nowMeter.lastDeductionFeeTime).formatByTime()}}</span></p>
							<p class="infoItemContainer"><span class="infoTitle">上次扣费金额：</span><span class="infoContent"><span class="moneyNum">{{lastKF}}</span> 元</span></p>
						</div>
					</div>
				</div>
				<div v-if="nowMeter.billingMode == 'StepBilling'" class="detailDiv" style="width: calc(50% - 25px);height: 154px;">
					<p class="detailTitle">计费方式</p>
					<table>
						<tr>
							<th>阶梯</th>
							<th>区间 (kW·h)</th>
							<th>单价 (元/kW·h)</th>
						</tr>
						<tr v-for="(item,index) in nowStepList">
							<td>{{index+1}}</td>
							<td v-if="index != nowStepList.length - 1">【{{index == 0?0:nowStepList[index -1].step}}】- 【{{item.step}}】</td>
							<td v-else>【{{nowStepList[index - 1].step}}】以上</td>
							<td><span class="moneyNum">{{item.price}}</span></td>
						</tr>
					</table>
				</div>
			</div>
			<div class="flexBetween" style="margin-top: 10px;">
				<div class="detailDiv" style="width: calc(50% - 5px);height: 250px;margin-right: 10px;">
					<p class="detailTitle">账单列表</p>
					<div class="custom-scrollbar" style="height: calc(100% - 30px);">
						<p class="contentItem" v-for="item in recordList" v-html="recordMessage(item)"></p>
					</div>
				</div>
				<div class="detailDiv" style="width: calc(50% - 5px);height: 250px;">
					<p class="detailTitle">事件列表</p>
					<div class="custom-scrollbar" style="height: calc(100% - 30px);">
						<p class="contentItem" v-for="item in nowEventList">{{item.description}}</p>
					</div>
				</div>
			</div>
			<!--图表-->
			<div class="detailDiv" style="margin-top: 10px;height: calc(100% - 174px - 270px - 60px);">
				<vchart style="height: 100%" ref='vchart'></vchart>
			</div>
		</div>
	</div>
</template>

<script>
	import iconButton from '@/components/module/universal/iconButton.vue'
	import createMeterDialog from './createMeterDialog.vue'
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			iconButton,
			createMeterDialog,
			vchart
		},
		props: {
			nowMeter: {
				type: Object,
				default () {
					return {}
				}
			}
		},
		data() {
			return {
				meterRecord: {},
				meterEvent: {},
				meterHistory: [],
				options: {},
			}
		},
		created() {},
		mounted() {
			debugPage = this
			//初始化图表
			this.options = this.$refs.vchart.getDefaultOptions()
			this.options.tooltip.formatter = (params, ticket, callback) => {
				if (params[0].data == undefined) {
					return ""
				}
				var h = params[0].data[0]
				var label = h + "日</br>"
				params.forEach(item => {
					var values;
					if (isnull(item.data[1])) {
						values = "无采集数据";
					} else {
						values = cutDigital(item.data[1]);
					}
					label += item.seriesName + " : " + values + " (kW·h)</br>"
				})
				return label;
			}
			this.options.yAxis = {
				splitLine: {
					show: true
				}
			}
			this.options.grid.bottom = 0
			this.options.title.text = "日用电统计"
			this.$refs.vchart.setData(this.options, true)
		},
		destroyed() {},
		computed: {
			haveMargin() {
				if(this.nowMeter.billingMode == 'StepBilling'){
					return {
						'flex-grow': '1',
						'margin-right': '10px'
					}
				}else{
					return {
						'flex-grow': '1'
					}
				}
			},
			nowBalance() {
				if (this.nowMeter.id == undefined) {
					return '--'
				}
				var balance = this.$store.moneyStore.getters.getBalance(this.nowMeter.id, 'MeterReading')
				if (balance == undefined) {
					return '--'
				}
				return balance.balance / 100
			},
			billingMode() {
				return mode => {
					switch (mode) {
						case 'StepBilling':
							return '阶梯计费'
						case 'PeakAndValleyBilling':
							return '峰平谷计费'
						case 'SingleBilling':
							return '单价计费'
						default:
							return '无效计费' + mode
					}
				}
			},
			recordList() {
				if (isempty(this.meterRecord)) {
					return []
				}
				return this.meterRecord.dataList
			},
			lastKF() {
				var order = this.recordList.find(item => item.detailType == 'Meter_Reading')
				if (order != undefined) {
					return order.amount / 100
				}
				return '--'
			},
			recordMessage(){
				return record => {
					switch (record.detailType) {
						case 'Recharge_AliPay':
							return '【' + this.$store.moneyStore.state.payState[record.state] + '】' + '【' + new Date(record.createTime).formatByTime('-') +
								'】通过【支付宝】充值【' + '<span style="color: #4BBAEF;font-size:.16rem;">' + (record.amount / 100) + '</span>' + '】元'
						case 'Meter_Reading':
							return '【' + new Date(record.createTime).formatByTime('-') + '】通过【用电抄表】扣费【' + '<span style="color: #4BBAEF;font-size:.16rem;">' + (record.amount / 100) + '</span>' + '】元'
					}
				}
			},
			nowStepList() {
				if (this.nowMeter.deductionStandard != undefined) {
					return this.nowMeter.deductionStandard.split(';').map(item => {
						var s = item.split(':')
						return {
							step: s.length > 1 ? s[0] : undefined,
							price: s.length > 1 ? s[1] : s[0]
						}
					})
				}
				return []
			},
			nowEventList() {
				return getValueIfNoNull(this.meterEvent.data, [])
			},
			powerVariable() {
				var list = this.$store.variableStore.getters.getVariableTree(this.nowMeter.id, [36])
				if (isempty(list) || isempty(list[0].next)) {
					return undefined
				}
				return list[0].next[0]
			},
			showControl() {
				var list = this.$store.deviceStore.getters.getControlDeviceList
				return list.map(item=>item.no).includes(this.nowMeter.deviceNo)
			}
		},
		watch: {
			nowMeter(nv, ov) {
				this.loadRecord(nv.id)
				this.loadDeviceEvent(nv.id)
			},
			powerVariable(nv, ov) {
				if (nv == undefined) {
					this.meterHistory = []
				} else {
					var now = new Date()
					this.$api.historyApi.getHistoryDifferenceRanking(nv.fromName, 'month', new Date(now.getFullYear(), now.getMonth(),
						1,).getTime(), '', respon => {
						this.meterHistory = respon[nv.fromName]
					})
				}
			},
			meterHistory(nv, ov) {
				this.reloadChart(nv)
			}
		},
		methods: {
			closeDetails() {
				this.$emit('closeDetails')
			},
			loadRecord(deviceNo) {
				if (deviceNo == undefined) {
					this.meterRecord = {}
					return
				}
				this.$api.recordApi.searchRecordLimit(deviceNo,'MeterReading', 1, 100, undefined, undefined, undefined, respon => {
					this.meterRecord = respon
				})
			},
			loadDeviceEvent(deviceNo) {
				if (deviceNo == undefined) {
					this.meterEvent = {}
					return
				}
				this.$api.eventApi.searchEventListByUser(undefined, this.$store.unitStore.getters.getNowUnit.id, undefined, -1, -1,
					deviceNo, new Date().getTime() - 180 * 24 * 60 * 60 * 1000,
					Date.now(), 1, 100, '', respon => {
						this.meterEvent = respon
					})
			},
			editMeter() {
				//添加计费表
				this.$refs.createMeterBean.show(this.nowMeter, true)
			},
			reloadChart(list) {
				this.options.series = [{
					name: "每日用电量",
					type: 'bar',
					smooth: true,
					symbol: 'emptyCircle',
					markPoint: {
						data: [{
							name: '最大值',
							type: 'max'
						}]
					},
					sampling: 'average',
					data: list.map((item, index) => [index + 1, item])
				}]
				this.$refs.vchart.setData(this.options, true)
			},
		}
	}
</script>

<style scoped>
	.meterDetailBody{
		margin: 0 10px;
	}

	.detailDiv {
		background: white;
		border-radius: 5px;
		padding: 10px;
	}

	.detailTitle {
		font-size: .16rem;
		font-weight: 600;
		line-height: 20px;
		border-left: solid 4px #3D7EFF;
		padding-left: 8px;
		margin-bottom: 8px;
	}
	
	.infoItemContainer{
		margin: 10px 0;
	}
	
	.contentItem{
		margin: 10px 0;
		font-size: .16rem;
		color: gray;
	}

	.detailDiv table {
		width: 100%;
	}

	.detailDiv table td,table th {
		font-size: .16rem;
		color: #555555;
		text-align: center;
		padding: 3px 30px;
	}
	
	.detailDiv table td{
		color: gray;
	}
	
	.detailDiv table td>span{
		font-size: .16rem;
	}

	span.infoTitle {
		color: gray;
		font-size: .16rem;
	}
	
	span.infoContent{
		float: right;
		font-size: .16rem;
	}
	
	span.infoContent>span{
		font-size: .16rem;
	}
	
	span.moneyNum{
		color: #4BBAEF;
	}
</style>
